module.exports = __webpack_public_path__ + "static/media/jenga-bar.db1bfcce.jpg";